import { takeEvery } from '@zaibot/fsa-saga';
import { fork, put } from '../../redux-saga';
import { bookmarksBatch, bookmarksEditor } from '../bookmarks/resource';
import { categoriesResource } from '../categories/resource';
import { notesBatch, notesEditor } from '../notes/resource';
import SELECT from './actions/SELECT';
import FLYOVER_HIDE from '../../note/flyover/actions/HIDE';
import HIDE from './actions/HIDE';

export default function* rootSaga() {
    yield fork(updateEditors);
    yield fork(updateEditorsAfterCloseFlyover);
}

function* updateEditors() {
    yield takeEvery(categoriesResource.actions.CREATE_SUCCESS, function*(action) {
        const categoryId = action.payload.item.id;
        // Note Editors
        yield put(notesEditor.actions.APPLY({ item: { categoryId } }));
        yield put(notesBatch.actions.APPLY({ item: { categoryId } }));
        // Bookmark Editors
        yield put(bookmarksEditor.actions.APPLY({ item: { categoryId } }));
        yield put(bookmarksBatch.actions.APPLY({ item: { categoryId } }));
        // Popup
        yield put(SELECT({ categoryId }));
    });
}

function* updateEditorsAfterCloseFlyover() {
    yield takeEvery(FLYOVER_HIDE, function*(action) {
        // Popup
        yield put(HIDE({}));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categorySelectPopup/sagas.tsx